import React from 'react'

export default function Convocation() {
    return (
        <div>Convocation</div>
    )
}
